import { cn } from "@/lib/utils";

// Unified list row index: "#1" style. See DESIGN.md "列表行序号".
export const RowIndex = ({
  n,
  className,
  title,
}: {
  n: number | string;
  className?: string;
  title?: string;
}) => (
  <span
    title={title}
    className={cn(
      "w-8 shrink-0 text-sm tabular-nums text-muted-foreground",
      className
    )}
  >
    #{n}
  </span>
);

export default RowIndex;
